module.exports = __webpack_public_path__ + "static/headshot-bw-f89a861cc1a81c1fdb094bd8de552b66.webp";